import React from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import InfoChartMap from './InfoChartMap';
import NoDataDialog from './NoDataDialog';
import { showView, reportReset } from '../actions/index';
import useLoadReport from '../hooks/useLoadReport';

const SpeedView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { viewName } = useParams();
  const history = useHistory();

  const data = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      type: 'speed',
      objectId: queryParams.get('object'),
      start: moment(queryParams.get('start')),
      end: moment(queryParams.get('end')),
    };
  }, [location.search]);

  // const hasMissingParams = !data.objectId || !data.start || !data.end;

  const loadReport = useLoadReport(data);

  React.useEffect(() => {
    if (viewName === 'speed') {
      loadReport.loadAsync().then(() => {
        // Report loaded successfully
      });
    }
    return () => loadReport.controller.abort();
  }, [loadReport, viewName]);

  const onConfirm = () => {
    history.goBack();
    dispatch(reportReset('speed'));
  };
  const speedReport = useSelector(state => state.report.speed);
  const errorDialog = speedReport.status === 'nodata';
  const reportType =
    speedReport.status === 'nodata' || speedReport.status === 'loading'
      ? 'loading'
      : 'speed';

  return (
    <React.Fragment>
      {errorDialog && (
        <NoDataDialog
          open={true}
          onClose={onConfirm}
          objectName={speedReport.objectName}
          startDate={speedReport.start}
          endDate={speedReport.end}
        />
      )}
      <InfoChartMap type={reportType} object={speedReport} />
    </React.Fragment>
  );
};

// ViewStack.propTypes = {
//   views: PropTypes.object,
//   show: PropTypes.string,
// };

export default SpeedView;
